module.exports = __webpack_public_path__ + "img/pause.658d840a.svg";